import React, { Component } from "react";
import VacationForm from "../VacationForm/VacationForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : VacationPage
Description : Componente que contienen el formulario de la pantalla Vacation 
Date Autor Modification
================================================================================
2/11/2021 Cristian Andres Pizo Mina – Se llama al componente VacationForm
================================================================================ */
class VacationPage extends Component{
    render(){
        return(
            <div>                    
                <VacationForm/>
            </div>
        )   
    }
}

export default VacationPage;